import React, { FC } from 'react';

import classNames from 'classnames';

export enum HeaderSize {
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
  HERO = 'hero',
}

export interface HeaderInterface {
  omitSizeString?: boolean;
  size: HeaderSize;
  text: any;
  applyUpperCasing?: boolean;
  align?: 'left' | 'center' | 'right';
  classes?: string;
  role?: string;
  isFullWidth?: boolean;
  hoverEffect?: boolean;
}

const mapSizeToClassName = {
  h1: 'text-h1 md:text-d-h1',
  h2: 'text-h2 md:text-d-h2',
  h3: 'text-h3 md:text-d-h3',
  h4: 'text-h4 md:text-d-h4',
  hero: 'text-hero md:text-d-hero',
};

const HeaderText: FC<HeaderInterface> = ({
  omitSizeString,
  size = HeaderSize.H1,
  text,
  align,
  classes = '',
  role = 'heading',
  applyUpperCasing,
  isFullWidth = true,
  hoverEffect,
}) => {
  if (!text) {
    return null;
  }

  const element = size == HeaderSize.HERO ? 'h1' : size;

  return React.createElement(
    element,
    {
      role,
      className: classNames('font-bold', {
        [classes]: classes,
        'text-charcoal-v2': !hoverEffect,
        'w-full': isFullWidth,
        'title-container': align === 'center',
        [`text-${align}`]: align,
        [mapSizeToClassName[size]]: !omitSizeString,
        uppercase: applyUpperCasing,
      }),
      'data-testid': `text-headerText-${size}`,
    },
    text,
  );
};

export default React.memo(HeaderText);
